import getConfig from 'next/config';

import { useTheme } from '@sravni/react-utils';

const { readingNowWidgetUrl } = getConfig().publicRuntimeConfig;

export const ReadingNowWidget = () => {
  const [theme] = useTheme();

  return (
    <iframe
      src={`${readingNowWidgetUrl}/ugc-widgets/news-widget/vertical/banner/${theme}`}
      style={{
        width: '300px',
        height: '500px',
        border: 'none',
      }}
      title="Реклама"
      data-advertising-wiget
    />
  );
};
